module.exports = __webpack_public_path__ + "assets/img/1-2.b05c638b.jpg";